import React, { useState, Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon, UploadIcon } from 'lucide-react';
const AssetsAndInsurance = () => {
  const {
    register,
    watch
  } = useFormContext();
  const [realEstateProperties, setRealEstateProperties] = useState([{
    id: 1
  }]);
  const [lifeInsurancePolicies, setLifeInsurancePolicies] = useState([{
    id: 1
  }]);
  const addRealEstate = () => {
    const newId = realEstateProperties.length > 0 ? Math.max(...realEstateProperties.map(p => p.id)) + 1 : 1;
    setRealEstateProperties([...realEstateProperties, {
      id: newId
    }]);
  };
  const removeRealEstate = (id: number) => {
    setRealEstateProperties(realEstateProperties.filter(p => p.id !== id));
  };
  const addLifeInsurance = () => {
    const newId = lifeInsurancePolicies.length > 0 ? Math.max(...lifeInsurancePolicies.map(p => p.id)) + 1 : 1;
    setLifeInsurancePolicies([...lifeInsurancePolicies, {
      id: newId
    }]);
  };
  const removeLifeInsurance = (id: number) => {
    setLifeInsurancePolicies(lifeInsurancePolicies.filter(p => p.id !== id));
  };
  return <div className="space-y-8" data-id="element-217">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-218">
        <p className="text-slate-700" data-id="element-219">
          Please provide information about your assets and insurance policies.
        </p>
      </div>

      {/* Joint Ownership */}
      <div className="space-y-4" data-id="element-220">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-221">
          Joint Ownership
        </h3>

        <div data-id="element-222">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-223">
            Do you have any assets (accounts, title to a property) that you are
            on with another person other than a spouse?
          </label>
          <p className="text-sm text-slate-600 mb-3" data-id="element-224">
            Examples include being a joint account holder of a parent's bank
            account, or on title to a child's property for 1%. This includes if
            you have a child as a joint account holder on a bank account.
          </p>
          <div className="flex items-center space-x-4 mb-4" data-id="element-225">
            <label className="inline-flex items-center" data-id="element-226">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('jointOwnership.exists')} data-id="element-227" />
              <span className="ml-2" data-id="element-228">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-229">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('jointOwnership.exists')} data-id="element-230" />
              <span className="ml-2" data-id="element-231">No</span>
            </label>
          </div>

          {watch('jointOwnership.exists') === 'true' && <div data-id="element-232">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-233">
                With whom and what assets?
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Please describe the joint ownership arrangements" {...register('jointOwnership.details')} data-id="element-234" />
            </div>}
        </div>
      </div>

      {/* Registered Accounts */}
      <div className="space-y-4" data-id="element-235">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-236">
          Registered Accounts
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-237">
          <div className="p-4 bg-slate-50 rounded-md" data-id="element-238">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-239">RRSP</label>
            <div className="space-y-3" data-id="element-240">
              <div data-id="element-241">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-242">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-243">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-244">
                    <span className="text-slate-500" data-id="element-245">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('registeredAccounts.rrsp.value')} data-id="element-246" />
                </div>
              </div>
              <div data-id="element-247">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-248">
                  Designated Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('registeredAccounts.rrsp.beneficiary')} data-id="element-249" />
              </div>
            </div>
          </div>

          <div className="p-4 bg-slate-50 rounded-md" data-id="element-250">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-251">RIF</label>
            <div className="space-y-3" data-id="element-252">
              <div data-id="element-253">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-254">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-255">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-256">
                    <span className="text-slate-500" data-id="element-257">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('registeredAccounts.rif.value')} data-id="element-258" />
                </div>
              </div>
              <div data-id="element-259">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-260">
                  Designated Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('registeredAccounts.rif.beneficiary')} data-id="element-261" />
              </div>
            </div>
          </div>

          <div className="p-4 bg-slate-50 rounded-md" data-id="element-262">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-263">TFSA</label>
            <div className="space-y-3" data-id="element-264">
              <div data-id="element-265">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-266">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-267">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-268">
                    <span className="text-slate-500" data-id="element-269">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('registeredAccounts.tfsa.value')} data-id="element-270" />
                </div>
              </div>
              <div data-id="element-271">
                <label className="block text-sm text-slate-600 mb-1" data-id="element-272">
                  Designated Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('registeredAccounts.tfsa.beneficiary')} data-id="element-273" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* RESP */}
      <div className="space-y-4" data-id="element-274">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-275">
          RESP (Registered Education Savings Plan)
        </h3>

        <div data-id="element-276">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-277">
            Do you have an RESP?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-278">
            <label className="inline-flex items-center" data-id="element-279">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('resp.exists')} data-id="element-280" />
              <span className="ml-2" data-id="element-281">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-282">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('resp.exists')} data-id="element-283" />
              <span className="ml-2" data-id="element-284">No</span>
            </label>
          </div>

          {watch('resp.exists') === 'true' && <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-285">
              <div data-id="element-286">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-287">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-288">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-289">
                    <span className="text-slate-500" data-id="element-290">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('resp.value')} data-id="element-291" />
                </div>
              </div>
              <div data-id="element-292">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-293">
                  Beneficiary
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('resp.beneficiary')} data-id="element-294" />
              </div>
            </div>}
        </div>
      </div>

      {/* Real Estate */}
      <div className="space-y-4" data-id="element-295">
        <div className="flex justify-between items-center" data-id="element-296">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-297">
            Real Estate
          </h3>
          <button type="button" onClick={addRealEstate} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-298">
            <PlusIcon size={16} className="mr-1" data-id="element-299" />
            Add Property
          </button>
        </div>

        <div data-id="element-300">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-301">
            Do you own real estate?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-302">
            <label className="inline-flex items-center" data-id="element-303">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('assets.realEstate.exists')} data-id="element-304" />
              <span className="ml-2" data-id="element-305">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-306">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('assets.realEstate.exists')} data-id="element-307" />
              <span className="ml-2" data-id="element-308">No</span>
            </label>
          </div>

          {watch('assets.realEstate.exists') === 'true' && <>
              {realEstateProperties.map((property, index) => <div key={property.id} className="p-4 bg-slate-50 rounded-md mb-4" data-id="element-309">
                  <div className="flex justify-between items-center mb-3" data-id="element-310">
                    <h4 className="font-medium" data-id="element-311">Property {index + 1}</h4>
                    {realEstateProperties.length > 1 && <button type="button" onClick={() => removeRealEstate(property.id)} className="text-red-500 hover:text-red-700" data-id="element-312">
                        <TrashIcon size={16} data-id="element-313" />
                      </button>}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-314">
                    <div className="md:col-span-2" data-id="element-315">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-316">
                        Address
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Full property address" {...register(`assets.realEstate.properties.${index}.address`)} data-id="element-317" />
                    </div>
                    <div data-id="element-318">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-319">
                        How is title held?
                      </label>
                      <select className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" {...register(`assets.realEstate.properties.${index}.titleType`)} data-id="element-320">
                        <option value="" data-id="element-321">Please select</option>
                        <option value="jointTenants" data-id="element-322">Joint Tenants</option>
                        <option value="tenantsInCommon" data-id="element-323">
                          Tenants in Common
                        </option>
                        <option value="sole" data-id="element-324">Sole Ownership</option>
                      </select>
                    </div>

                    {/* Show co-owner details if Joint Tenants or Tenants in Common */}
                    {(watch(`assets.realEstate.properties.${index}.titleType`) === 'jointTenants' || watch(`assets.realEstate.properties.${index}.titleType`) === 'tenantsInCommon') && <div className="md:col-span-2" data-id="element-325">
                        <label className="block text-navy-800 font-medium mb-2" data-id="element-326">
                          {watch(`assets.realEstate.properties.${index}.titleType`) === 'tenantsInCommon' ? 'Other owner(s) and percentage of ownership' : 'Other owner(s)'}
                        </label>
                        <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder={watch(`assets.realEstate.properties.${index}.titleType`) === 'tenantsInCommon' ? 'e.g., Jane Doe – 50%, John Doe – 50%' : 'e.g., Jane Doe (spouse)'} {...register(`assets.realEstate.properties.${index}.coOwnerDetails`)} data-id="element-327" />
                      </div>}

                    <div data-id="element-328">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-329">
                        Approximate Value
                      </label>
                      <div className="relative" data-id="element-330">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-331">
                          <span className="text-slate-500" data-id="element-332">$</span>
                        </div>
                        <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register(`assets.realEstate.properties.${index}.value`)} data-id="element-333" />
                      </div>
                    </div>
                    <div data-id="element-334">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-335">
                        Approximate Mortgage Owing
                      </label>
                      <div className="relative" data-id="element-336">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-337">
                          <span className="text-slate-500" data-id="element-338">$</span>
                        </div>
                        <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register(`assets.realEstate.properties.${index}.mortgageOwing`)} data-id="element-339" />
                      </div>
                    </div>
                  </div>
                </div>)}
            </>}
        </div>
      </div>

      {/* Pensions */}
      <div className="space-y-4" data-id="element-340">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-341">
          Pensions
        </h3>

        <div data-id="element-342">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-343">
            What pensions do you have?
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Company pension, Government pension" {...register('pensions.details')} data-id="element-344" />
        </div>

        <div data-id="element-345">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-346">
            Who is the beneficiary on the pension plan, if applicable?
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register('pensions.beneficiary')} data-id="element-347" />
        </div>
      </div>

      {/* Life Insurance */}
      <div className="space-y-4" data-id="element-348">
        <div className="flex justify-between items-center" data-id="element-349">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-350">
            Life Insurance
          </h3>
          <button type="button" onClick={addLifeInsurance} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-351">
            <PlusIcon size={16} className="mr-1" data-id="element-352" />
            Add Policy
          </button>
        </div>

        <div data-id="element-353">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-354">
            Do you have life insurance?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-355">
            <label className="inline-flex items-center" data-id="element-356">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('insurance.life.exists')} data-id="element-357" />
              <span className="ml-2" data-id="element-358">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-359">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('insurance.life.exists')} data-id="element-360" />
              <span className="ml-2" data-id="element-361">No</span>
            </label>
          </div>

          {watch('insurance.life.exists') === 'true' && <>
              {lifeInsurancePolicies.map((policy, index) => <div key={policy.id} className="p-4 bg-slate-50 rounded-md mb-4" data-id="element-362">
                  <div className="flex justify-between items-center mb-3" data-id="element-363">
                    <h4 className="font-medium" data-id="element-364">Policy {index + 1}</h4>
                    {lifeInsurancePolicies.length > 1 && <button type="button" onClick={() => removeLifeInsurance(policy.id)} className="text-red-500 hover:text-red-700" data-id="element-365">
                        <TrashIcon size={16} data-id="element-366" />
                      </button>}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-367">
                    <div data-id="element-368">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-369">
                        Insurer
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Insurance company name" {...register(`insurance.life.policies.${index}.insurer`)} data-id="element-370" />
                    </div>
                    <div data-id="element-371">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-372">
                        Policy Owner
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of policy owner" {...register(`insurance.life.policies.${index}.owner`)} data-id="element-373" />
                    </div>
                    <div data-id="element-374">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-375">
                        Insured Person
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of insured" {...register(`insurance.life.policies.${index}.insured`)} data-id="element-376" />
                    </div>
                    <div data-id="element-377">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-378">
                        Beneficiary
                      </label>
                      <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Name of beneficiary" {...register(`insurance.life.policies.${index}.beneficiary`)} data-id="element-379" />
                    </div>
                    <div data-id="element-380">
                      <label className="block text-navy-800 font-medium mb-2" data-id="element-381">
                        Face Value
                      </label>
                      <div className="relative" data-id="element-382">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-383">
                          <span className="text-slate-500" data-id="element-384">$</span>
                        </div>
                        <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register(`insurance.life.policies.${index}.value`)} data-id="element-385" />
                      </div>
                    </div>
                  </div>
                </div>)}
            </>}
        </div>
      </div>

      {/* Foreign Assets */}
      <div className="space-y-4" data-id="element-386">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-387">
          Foreign Assets
        </h3>

        <div data-id="element-388">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-389">
            Do you own assets in a different jurisdiction?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-390">
            <label className="inline-flex items-center" data-id="element-391">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('foreignAssets.exists')} data-id="element-392" />
              <span className="ml-2" data-id="element-393">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-394">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('foreignAssets.exists')} data-id="element-395" />
              <span className="ml-2" data-id="element-396">No</span>
            </label>
          </div>

          {watch('foreignAssets.exists') === 'true' && <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-397">
              <div data-id="element-398">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-399">
                  Jurisdiction
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., United States, United Kingdom" {...register('foreignAssets.jurisdiction')} data-id="element-400" />
              </div>
              <div data-id="element-401">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-402">
                  Description of Asset
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Real estate, Bank account" {...register('foreignAssets.description')} data-id="element-403" />
              </div>
              <div data-id="element-404">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-405">
                  Approximate Value
                </label>
                <div className="relative" data-id="element-406">
                  <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-407">
                    <span className="text-slate-500" data-id="element-408">$</span>
                  </div>
                  <input type="text" className="w-full pl-7 px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="0.00" {...register('foreignAssets.value')} data-id="element-409" />
                </div>
              </div>
            </div>}
        </div>
      </div>

      {/* Digital Assets */}
      <div className="space-y-4" data-id="element-410">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-411">
          Digital Assets
        </h3>

        <div data-id="element-412">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-413">
            Please list any digital assets (cryptocurrency, online accounts with
            value, etc.)
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Bitcoin wallet, PayPal balance, domain names" {...register('assets.digital')} data-id="element-414" />
        </div>
      </div>

      {/* Debts */}
      <div className="space-y-4" data-id="element-415">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-416">
          Debts
        </h3>

        <div data-id="element-417">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-418">
            Please provide a complete list of your debts, including values
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="e.g., Credit card debt: $5,000, Line of credit: $10,000, Car loan: $15,000" {...register('debts.owed')} data-id="element-419" />
        </div>

        <div data-id="element-420">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-421">
            Do you have any debts owing to you (e.g., by a promissory note)?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-422">
            <label className="inline-flex items-center" data-id="element-423">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('debts.owedToYou.exists')} data-id="element-424" />
              <span className="ml-2" data-id="element-425">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-426">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('debts.owedToYou.exists')} data-id="element-427" />
              <span className="ml-2" data-id="element-428">No</span>
            </label>
          </div>

          {watch('debts.owedToYou.exists') === 'true' && <div data-id="element-429">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-430">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Describe debts owed to you, including amounts and from whom" {...register('debts.owedToYou.details')} data-id="element-431" />
            </div>}
        </div>
      </div>

      {/* Gifts to Children */}
      <div className="space-y-4" data-id="element-432">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-433">
          Gifts to Children
        </h3>

        <div data-id="element-434">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-435">
            Have you made any gifts to any child that you are expecting to be
            equalized amongst other children upon your death?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-436">
            <label className="inline-flex items-center" data-id="element-437">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('giftsToChildren.exists')} data-id="element-438" />
              <span className="ml-2" data-id="element-439">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-440">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('giftsToChildren.exists')} data-id="element-441" />
              <span className="ml-2" data-id="element-442">No</span>
            </label>
          </div>

          {watch('giftsToChildren.exists') === 'true' && <div data-id="element-443">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-444">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Describe the gifts made and to which children" {...register('giftsToChildren.details')} data-id="element-445" />
            </div>}
        </div>
      </div>

      {/* Other Assets */}
      <div className="space-y-4" data-id="element-446">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-447">
          Other Valuable Assets
        </h3>

        <div data-id="element-448">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-449">
            Please list any other valuable assets
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="e.g., Vehicles, Art, Jewelry, Collections" {...register('assets.other')} data-id="element-450" />
        </div>

        <div data-id="element-451">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-452">
            Upload Full Asset List (optional)
          </label>
          <div className="border-2 border-dashed border-slate-300 rounded-md p-4 text-center" data-id="element-453">
            <UploadIcon className="mx-auto h-12 w-12 text-slate-400" data-id="element-454" />
            <p className="mt-2 text-sm text-slate-600" data-id="element-455">
              Drag and drop your file here, or click to select
            </p>
            <input type="file" className="hidden" id="asset-list-upload" {...register('assets.uploadedList')} data-id="element-456" />
            <button type="button" onClick={() => document.getElementById('asset-list-upload')?.click()} className="mt-2 px-4 py-2 bg-navy-700 text-white text-sm rounded-md hover:bg-navy-800" data-id="element-457">
              Select File
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default AssetsAndInsurance;